import isbn from "isbn3";
// isbn3 ships no range data for the ISMN prefix 979-0; publisher lengths per the ISMN Users' Manual
var ISMN_RANGES = [
    { from: 0, to: 99, length: 3 },
    { from: 1000, to: 3999, length: 4 },
    { from: 40000, to: 69999, length: 5 },
    { from: 700000, to: 899999, length: 6 },
    { from: 9000000, to: 9999999, length: 7 },
];
var hasValidEan13CheckDigit = function (digits) {
    var sum = digits
        .slice(0, 12)
        .split("")
        .reduce(function (acc, digit, index) { return acc + Number(digit) * (index % 2 === 0 ? 1 : 3); }, 0);
    return (10 - (sum % 10)) % 10 === Number(digits[12]);
};
var formatIsmn = function (cleaned) {
    var digits = cleaned.replace(/-/g, "").replace(/^M/i, "9790");
    if (!/^9790\d{9}$/.test(digits) || !hasValidEan13CheckDigit(digits)) {
        return null;
    }
    var block = digits.slice(4, 12);
    var range = ISMN_RANGES.find(function (_a) {
        var from = _a.from, to = _a.to, length = _a.length;
        var publisher = Number(block.slice(0, length));
        return publisher >= from && publisher <= to;
    });
    if (!range) {
        return null;
    }
    return "979-0-".concat(block.slice(0, range.length), "-").concat(block.slice(range.length), "-").concat(digits[12]);
};
/**
 * Formats a raw ISBN/ISMN for display with the canonical hyphenation
 * (e.g. "9788020417282" -> "978-80-204-1728-2", ISMN "9790260000438" -> "979-0-2600-0043-8").
 *
 * Hyphen placement depends on the official ISBN registration-group/registrant ranges,
 * so ISBN is delegated to `isbn3` (bundles the range data) and ISMN uses ISMN_RANGES. When the value cannot be parsed
 * as a valid ISBN/ISMN the raw input is returned unchanged — never a wrong hyphenation and
 * never data loss.
 */
export var formatIsbn = function (raw) {
    var _a, _b;
    if (!raw) {
        return "";
    }
    var cleaned = raw.replace(/\s+/g, "");
    var parsed = isbn.parse(cleaned);
    return (_b = (_a = parsed === null || parsed === void 0 ? void 0 : parsed.isbn13h) !== null && _a !== void 0 ? _a : formatIsmn(cleaned)) !== null && _b !== void 0 ? _b : raw;
};
export var isCompleteIsbn = function (raw) {
    var cleaned = (raw !== null && raw !== void 0 ? raw : "").replace(/\s+/g, "");
    return cleaned.length > 0 && (!!isbn.parse(cleaned) || !!formatIsmn(cleaned));
};
